import claimPodcastReducer from './reducer';

export * from './actions';
export * from './types';

export default claimPodcastReducer;
